import { useEffect, useState } from 'react';

import { facilityService } from '@/services';
import type { FacilityFilterOptions } from '@/services/FacilityService';

interface UseFilterOptionsResult {
  readonly options: FacilityFilterOptions;
  readonly loading: boolean;
  readonly error: string | null;
}

const DEFAULT_OPTIONS: FacilityFilterOptions = {
  statuses: [],
  provinces: [],
  facility_types: [],
};

export function useFilterOptions(): UseFilterOptionsResult {
  const [options, setOptions] = useState<FacilityFilterOptions>(DEFAULT_OPTIONS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    async function fetchOptions(): Promise<void> {
      try {
        const data = await facilityService.fetchFilterOptions();
        if (mounted) {
          setOptions(data);
          setError(null);
        }
      } catch (err) {
        if (mounted) {
          const message =
            err instanceof Error ? err.message : 'Failed to fetch filter options';
          setError(message);
          console.error('Error fetching filter options:', err);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    }

    void fetchOptions();

    return () => {
      mounted = false;
    };
  }, []);

  return { options, loading, error };
}
